import { UnlikelyVariant } from '@unlikelystudio/commerce-connector'

export function keepAvailableVariants(variants: UnlikelyVariant[]) {
  return (
    variants?.filter((variant) => variant?.availableForSale)?.length > 0 ??
    false
  )
}
